import { useEffect, useState } from 'react';
import { fetchData } from '../utils/fetch-data';

const useUpcomingEvents = ({ limit = 100, categoryIds = [] } = {}) => {
  const [ isLoading, setLoading ] = useState(false);
  const [ nodes, setNodes ] = useState([]);
  const ids = categoryIds.join(',');

  useEffect(() => {
    async function getEvents() {
      setLoading(true);

      const { data: json } = await fetchData(`/.netlify/functions/get-events?categoryIds=${ids}&limit=${limit}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
     
      if( json?.data?.upcomingEvents?.nodes ) {
        setNodes( json.data.upcomingEvents.nodes );
      }
      
      setLoading(false);
    }

    getEvents();
  }, [ limit ]);

  return { isLoading, nodes }
};

export default useUpcomingEvents;
